import { Box, useDisclosure } from '@chakra-ui/react';
import { useIsFetching } from '@tanstack/react-query';
import { useFilterState } from './hooks/useFilterState.tsx';
import { ProductCatalogue } from './components/ProductCatalogue.tsx';
import { CustomProductRequestModal } from './customProductRequest/CustomProductRequest.tsx';
import { CustomerNavDesktop } from './components/CustomerNavDesktop.tsx';
import { ShoppingCart } from './shoppingCart/ShoppingCart.tsx';
import { CheckoutModal } from './checkout/checkout.tsx';
import { CustomerNavMobile } from './components/CustomerNavMobile.tsx';
import { MobileBottomNav } from './components/MobileBottomNav.tsx';
import { CartSidebar } from './components/CartSidebar.tsx';
import { MobileSearchOverlay } from './components/MobileSearchOverlay.tsx';

export const ProductListing = () => {
  const { filterState, setKeyword, setFormIds } = useFilterState();
  const isSearching = useIsFetching({ queryKey: [{ scope: 'products' }] }) > 0;

  const customRequestDisclosure = useDisclosure();
  const cartDisclosure = useDisclosure();
  const checkoutDisclosure = useDisclosure();
  const searchDisclosure = useDisclosure();

  return (
    <Box bg={'white'}>
      {/* Mobile Layout */}
      <Box display={{ base: 'block', lg: 'none' }} minH='100vh'>
        <CustomerNavMobile />
        <Box p='5' pb='24' fontSize='sm'>
          <ProductCatalogue filterState={filterState} setFormIds={setFormIds} />
        </Box>
        <MobileBottomNav
          onCartClick={cartDisclosure.onOpen}
          onRequestClick={customRequestDisclosure.onOpen}
          onSearchClick={searchDisclosure.onOpen}
        />
        <MobileSearchOverlay disclosure={searchDisclosure} setSearchValue={setKeyword} />
      </Box>

      {/* Desktop Layout */}
      <Box display={{ base: 'none', lg: 'block' }}>
        <Box position='sticky' top='0' zIndex='10' bg='white'>
          <CustomerNavDesktop
            setSearchValue={setKeyword}
            isSearching={isSearching}
            onRequestClick={customRequestDisclosure.onOpen}
            onCartClick={cartDisclosure.onOpen}
          />
        </Box>
        <Box borderTopWidth='1px' borderColor='gray.200' bg='gray.50' minH='calc(100vh - 72px)'>
          <Box maxW='1600px' mx='auto' px='6' pt='6' pb='12'>
            <ProductCatalogue
              filterState={filterState}
              setFormIds={setFormIds}
              sidebar={<CartSidebar onViewCart={cartDisclosure.onOpen} onCheckout={checkoutDisclosure.onOpen} />}
            />
          </Box>
          {customRequestDisclosure.open && <CustomProductRequestModal disclosure={customRequestDisclosure} />}
        </Box>
      </Box>

      <ShoppingCart onCheckout={checkoutDisclosure.onOpen} disclosure={cartDisclosure} />
      <CheckoutModal disclosure={checkoutDisclosure} />
    </Box>
  );
};
